<template>
    <div style="display: flex; flex-direction: column; background: linear-gradient(180deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0.601454) 60%, rgba(255, 255, 255, 0.9) 80.4%, #FFFFFF 100%);">
        <div class="header" style="padding-bottom: 10px; position: relative;">
            <div style="left:0px; top:0px; width:100%; height:100%; position: absolute; overflow: hidden; display: flex; align-items: center;  background: linear-gradient(180deg, rgba(33, 15, 3, 0) 0%, rgba(33, 15, 3, 0.7) 70%, #210F03 100%);">
                <img style="width: 100%; object-fit: cover;" ref="preview" alt="">
                <input type="file" style="display:none;" accept="image/*" @change="readURL($event)" ref="imageFile">
            </div>
            <div style="position:relative; margin-top: 10px; margin-bottom: 20px; padding-left: 20px; display: flex; gap: 4px; align-items: center;" @click="() => { $GlobalStore.closeLastModal() }">
                <img style="width: 10px;" :src="require('@/assets/img/white_arrow.png')" alt="">
                <div style="color: #fff; font-size: 14px; font-weight: 500;">뒤로가기</div>
            </div>
            <div style="position:relative; text-align: center; color: #fff;">
                <div style="font-size: 20px;font-weight: 700;line-height: 24px; margin-bottom: 4px;">회원 관리 채팅</div>
                <div style="font-weight: 500; line-height: 24px;">전문가님이 코칭하는 회원들을<br>채팅으로 관리할 수 있습니다</div>
            </div>
            <div @click="setIsShowPopMenu" style="position: absolute; bottom: 12px; right: 12px;">
                <img style="width: 24px;" :src="require('@/assets/img/modify_img.png')" alt="">
            </div>
        </div>
        <div style="flex: 1; padding: 0 12px; overflow-y: scroll; padding-bottom: 30px;">
            <div style="margin-top: 40px;">
                <div class="title">채팅방 이름</div>
                <input @input="handleTitleLength" v-model="memberTalkInfo.title" placeholder="채팅방의 이름을 설정하세요" class="common_input" type="text">
                <div style="font-weight: 700; font-size: 12px; color: #bbbbbb; float: right; margin-top: 6px;">{{ memberTalkInfo.title.length }}/40</div>
            </div>
            <div style="margin-top: 44px;">
                <div class="title">채팅방 설명</div>
                <textarea @input="handleIntroLength" v-model="memberTalkInfo.introduce" placeholder="구분하기 쉽게 채팅방을 설명하세요" class="common_text_area" type="text"></textarea>
                <div style="font-weight: 700; font-size: 12px; color: #bbbbbb; float: right; margin-top: 6px;">{{ memberTalkInfo.introduce.length }}/200</div>
            </div>
            <div style="margin-top: 44px;">
                <div class="title">초대하기</div>
                <div style="margin-top: 8px; font-weight: 500; font-size: 12px; line-height: 20px; color: #808080;">트레이닝을 참여하셨던 회원이나, 다이렉트 요청서 및 메시지를 주고 받은 회원분들만 초대할 수 있습니다</div>
            </div>
            <div style="margin-top: 8px;">
                <MercenarySearchInput :enter="debounceAPISearch" :searchWord="searchWord" :setSearchWord="setSearchWord" :isShowCancelBtn="false" :placeholder="'검색'"></MercenarySearchInput>
                <div style="margin-top: 20px;">
                    <div @click="setInviteList(each)" v-for="each, i in invitationMembers" :key="i" style="display: flex; align-items: center; margin-bottom: 24px;">
                        <div style="margin-right: 8px;">
                            <ProfileImage :imagePath="each.image_path" style="width: 40px;"></ProfileImage>
                        </div>
                        <div style="flex: 1; display: flex; align-items: center; gap: 3px;">
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.nic_name }}</div>
                            <div style="font-weight: 700; font-size: 14px; color: var(--color-main);">{{ each.position }}</div>
                        </div>
                        <div v-if="inviteList.indexOf(each) !== -1">
                            <img style="width: 16px;" :src="require('@/assets/img/check_orange.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding-bottom: 40px;">
            <CommonBottomBtn :btnClickEvent="makeMemberTalk" :btnName="'만들기'"></CommonBottomBtn>
        </div>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
    </div>
</template>

<script>
import CommonBottomBtn from '@/components/common/CommonBottomBtn.vue';
import { ENJOY_TYPE } from '@/Constants';
import ResponseCode from '@/ResponseCode';
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import MercenarySearchInput from '@/components/common/MercenarySearchInput'
import ProfileImage from '@/components/common/ProfileImage'
import _ from 'lodash';

export default {
    name: 'MakeMemberTalk',
    components: { CommonBottomBtn, BottomPopupMenu, MercenarySearchInput, ProfileImage },
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            memberTalkInfo: {
                title: '',
                introduce: '',
                age: [],
                maxCnt: 0,
                tag: []
            },
            searchWord: '',
            memberTalkTag: ['매치 뛰기', '용병 모집', '조기축구', '친목', '국내축구', '해외축구', '팬클럽', '경기 직관', '레슨', '훈련', '유소년', '여자축구'],
            ENJOY_TYPE: ENJOY_TYPE,
            age: ['10대', '20대', '30대', '40대', '50대', '60대 이상'],
            maxCnt: [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 40, value: 40 },
                { label: 50, value: 50 },
                { label: 60, value: 60 },
                { label: 70, value: 70 },
            ],
            showScroll: false,
            isShowPopMenu: false,
            menuOptions: {},
            public_img_path: '',
            inviteList: [],
            invitationMembers: []
        }
    },
    created() {
        if (this.$Util.isShowDefaultSettings()) {
            return
        }

        if (this.isExpert) {
            this.memberTalkTag = ['훈련', '레슨', '유소년', '여자축구']
        }
        this.getInviteList()
        this.debounceAPISearch = _.debounce((e) => {
            this.enter(e);
        }, 600);
    },
    computed: {
        isExpert() {
            if (this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                return true
            } else {
                return false
            }
        },
        isExpertConfirmed() {
            if (this.$GlobalStore.loginInfo().is_coach === '1') {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        async getInviteList(searchWord) {
            const parameters = {}
            parameters.searchWord = searchWord

            const res = await this.$Axios.get('/api/join/invitation/available/list', { params: parameters })

            const invitationMembers = res.data.invitation_members
            this.invitationMembers = invitationMembers
        },
        setInviteList(test) {
            const index = this.inviteList.indexOf(test);
            if (index > -1) {
                this.inviteList.splice(index, 1);
            } else {
                this.inviteList.push(test);
            }
        },
        setSearchWord(searchWord) {
            this.searchWord = searchWord
        },
        enter(e) {
            this.searchWord = e.target.value
            this.getInviteList(this.searchWord)
        },
        readURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        this.$refs['preview'].src = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.');
                }
            }
        },
        changeBackColorTag(tag) {
            return this.memberTalkInfo.tag.includes(tag)
        },
        detectValueChange(selectedData) {
            this.memberTalkInfo.maxCnt = selectedData.value
        },
        selectMaxCnt() {
            this.showScroll = false
        },
        setShowScroll() {
            this.showScroll = true
        },
        // setAge(age) {
        //     if (age === '60대 이상') {
        //         this.memberTalkInfo.age = [age];
        //     } else {
        //         if (this.memberTalkInfo.age.includes('60대 이상')) {
        //             this.memberTalkInfo.age = this.memberTalkInfo.age.filter(selectedAges => selectedAges !== '60대 이상');
        //             this.memberTalkInfo.age.push(age);
        //         } else {
        //             if (this.memberTalkInfo.age.includes(age)) {
        //                 this.memberTalkInfo.age = this.memberTalkInfo.age.filter(selectedAges => selectedAges !== age);
        //             } else {
        //                 this.memberTalkInfo.age.push(age);
        //             }
        //         }
        //     }
        // },
        // setTag(tag) {
        //     if (this.memberTalkInfo.tag.includes(tag)) {
        //         this.memberTalkInfo.tag = this.memberTalkInfo.tag.filter(selectedTag => selectedTag !== tag)
        //     } else {
        //         if (this.memberTalkInfo.tag.length === 3) {
        //             alert('멤버톡 태그는 최대 3개까지 설정이 가능합니다.')
        //             return
        //         }
        //         this.memberTalkInfo.tag.push(tag)
        //     }
        // },
        changeDefaultImage() {
            let randomNum;
            let public_img_path;
            randomNum = parseInt(Math.random() * 30) + 1
            if (1 <= randomNum && randomNum < 10) {
                randomNum = '0' + randomNum
            }
            public_img_path = `/img/membertalk/membertalk_default_image_${randomNum}.jpg`
            this.public_img_path = public_img_path
            this.$refs.preview.src = public_img_path;

        },
        setIsShowPopMenu() {
            this.isShowPopMenu = true
            const labelAndAction = []

            labelAndAction.push(
                {
                    label: '기본 이미지로 변경', action: () => {
                        this.changeDefaultImage()
                        this.isShowPopMenu = false
                    },
                },
                // {
                //     label: '스쿼드 이미지로 변경', action: () => {
                //         console.log('스쿼드 이미지로 변경')
                //         this.isShowPopMenu = false
                //     },
                // },
                {
                    label: '앨범에서 선택', action: () => {
                        this.$refs.imageFile.click();
                        this.isShowPopMenu = false
                    },
                },
            )


            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        setTag(tag) {
            if (this.memberTalkInfo.tag[0] === tag) {
                this.memberTalkInfo.tag = []
                return
            }
            this.memberTalkInfo.tag = [tag]
        },
        setAge(age) {
            if (this.memberTalkInfo.age[0] === age) {
                this.memberTalkInfo.age = []
                return
            }
            this.memberTalkInfo.age = [age]
        },
        changeBackColorAge(age) {
            return this.memberTalkInfo.age.includes(age)
        },
        handleTitleLength() {
            if (this.memberTalkInfo.title.length > 40) {
                this.memberTalkInfo.title = this.memberTalkInfo.title.slice(0, 40)
            }
        },
        handleIntroLength() {
            if (this.memberTalkInfo.introduce.length > 200) {
                this.memberTalkInfo.introduce = this.memberTalkInfo.introduce.slice(0, 200)
            }
        },
        setEnjoyType(type) {
            this.memberTalkInfo.enjoy_type = type
        },
        async makeMemberTalk() {
            if (this.memberTalkInfo.title === null || this.memberTalkInfo.title === '') {
                this.$GlobalStore.showAlert('채팅방 이름을 입력해주세요.')
                return
            }

            if (this.memberTalkInfo.introduce === null || this.memberTalkInfo.introduce === '') {
                this.$GlobalStore.showAlert('채팅방 설명을 입력해주세요.')
                return
            }

            this.$GlobalStore.showProgress()
            const transformInviteList = []
            this.inviteList.forEach(item => {
                transformInviteList.push({
                    member_idx: item.member_idx,
                    member_type: item.is_temp_coach
                })
            })

            const formData = new FormData()
            formData.append('mode', 'insert')
            formData.append('title', this.memberTalkInfo.title)
            formData.append('introduce', this.memberTalkInfo.introduce)
            formData.append('img_public_path', this.public_img_path)
            formData.append('invitation_members', JSON.stringify(transformInviteList))

            if (this.$refs.imageFile.value !== '') {
                formData.append('file0', this.$refs.imageFile.files[0])
            }

            const res = await this.$Axios.post('/api/join/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.showGroupChatting(res.data.chat_idx, res.data.join_idx)
                this.completeAction();
            } else {
                console.log(res)
            }
            this.$GlobalStore.hideProgress()
        },
        async showGroupChatting(chat_idx, join_idx) {
            join_idx;
            this.$GlobalStore.closeLastModal();
            await this.$Axios.showChattingBySoccerJoinIdx(chat_idx)
            // const isPrivate = this.memberTalkInfo.enjoy_type === JOIN_WAY.APPROVE ? true : false
            // const res = await this.$Axios.get('/api/chat/auth', { params: { chat_idx: chat_idx } });
            // if (res.data.code === 0) {
            //     this.$GlobalStore.closeLastModal()
            //     this.$GlobalStore.addModal('JoinChat', {
            //         isNewMemberTalk: isPrivate, auth: res.data.auth, chat: res.data.chat, chatIdx: chat_idx,
            //         pTitle: this.memberTalkInfo.title, init_refer_idx: join_idx, completeAction: this.getJoinChats, user : res.data.user });
            // }
        }
    }
}
</script>

<style scoped>
.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}

.common_input {
    padding: 10px;
    padding-left: 12px;
    outline: none;
    width: 100%;
    border-radius: 12px;
    border: none;
    background-color: #f5f5f5;
}

.common_input::placeholder {
    color: #bbbbbb;
    font-weight: 700;
}

.select {
    background-color: var(--color-main);
}

.title {
    font-weight: 700;
    line-height: 23px;
    margin-bottom: 8px;
    font-size: 14px;
}

.common_text_area {
    padding: 10px;
    padding-left: 12px;
    outline: none;
    width: 100%;
    min-height: 72px;
    border-radius: 12px;
    border: none;
    resize: none;
    line-height: 23px;
    background-color: #f5f5f5;
}

.common_text_area::placeholder {
    color: #bbbbbb;
    font-weight: 700;
}

.header {
    background-image: url('~@/assets/img/sample.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}
</style>